import React, {Component, Fragment} from "react";
import {connect} from "react-redux";
import {IRootState} from "../../store";
import ApiService from "../ApiService";
import DispatchProps from "../../utils/DispatchProps";
import {DurableFunctionInstance} from "../../models/DurableFunctionInstance";
import JsonViewerCard from "../JsonViewerCard";
import LoadingPage from "../LoadingPage";
import MailroomDurableFunctionInstanceList from "../mailroom/MailroomDurableFunctionInstanceList";
import MailroomDurableFunctionInstanceHistory from "../mailroom/MailroomDurableFunctionInstanceHistory";


export interface DurableFunctionBrowserInstancePageProps {
    instanceId: string;
    apiService: ApiService;
}

export interface DurableFunctionBrowserInstancePageState {
    instance?: DurableFunctionInstance;
    output?: any;
}

class DurableFunctionBrowserInstancePage extends Component<DurableFunctionBrowserInstancePageProps & DispatchProps, DurableFunctionBrowserInstancePageState> {
    static displayName = DurableFunctionBrowserInstancePage.name;

    constructor(props: DurableFunctionBrowserInstancePageProps & DispatchProps) {
        super(props);

        this.state = {
            instance: undefined,
            output: undefined,
        };
    }

    public async componentDidMount() {
        this.props.apiService.getMailroomFunctionInstance(this.props.instanceId).then(instance => {
            this.setState({
                instance: instance
            })
        });
        
        this.props.apiService.getDurableFunctionInstanceOutput("mailroom",this.props.instanceId).then(output => {
            this.setState({
                output
            });
        });
    }
    
    public render() {
        
        if(!this.state.instance)
        {
            return <LoadingPage/>;
        }
        
        return (
            <Fragment>
                <MailroomDurableFunctionInstanceList
                    title={`${this.state.instance.Name} ${this.state.instance.durableFunctionInstanceId}`}
                    enableRowLinks={false}
                    instances={[this.state.instance]}
                    columns={MailroomDurableFunctionInstanceList.genericColumns}>
                </MailroomDurableFunctionInstanceList>

                <JsonViewerCard title={"Instance"} jsonObject={this.state.instance}/>

                <JsonViewerCard title={"Output"} jsonObject={this.state.output}/>
                
                <MailroomDurableFunctionInstanceHistory title={"History"} instanceId={this.props.instanceId}/>
            </Fragment>
        );
    };
}

export default connect(
    (state: IRootState, ownProps: { match: any }): DurableFunctionBrowserInstancePageProps => {

        return {
            instanceId: ownProps.match.params.instanceId,
            apiService: state.auth.apiService
        };
    }
)(DurableFunctionBrowserInstancePage)